import { useQuery, useQueryClient } from "@tanstack/react-query";
import API from "@src/API";
import { queryKeys } from "./keys";

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

async function fetchCareers() {
  const resp = await API.getAsync("/Person/Careers");
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not load careers");
  }
  const data = resp.jsonData || {};
  return {
    careers: asArray(data.careers),
    skills: asArray(data.skills),
  };
}

export function useCareersQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.careers(),
    queryFn: fetchCareers,
    staleTime: 30_000,
    ...options,
  });
}

export async function refreshCareers(queryClient) {
  await queryClient.invalidateQueries({ queryKey: queryKeys.careers() });
  await queryClient.refetchQueries({ queryKey: queryKeys.careers() });
}

export function useRefreshCareers() {
  const queryClient = useQueryClient();
  return () => refreshCareers(queryClient);
}
